import React, { Component } from "react";

class MoveForm extends Component {
  render() {
    return (
      <>
        <div className={this.props.workingModal ? "" : "hide"}>
          <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
            CARGANDO INFORMACIÓN
          </div>
        </div>

        <div className={this.props.workingModal ? "hide" : ""}>
          <fieldset className="col-md-12">
            <legend>DATOS</legend>

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label>Establecimiento que envía:</label>
                  <div className="form-control">
                    {this.props.state.bitacora_producto
                      ? this.props.state.bitacora_producto.bitacora_movimiento.establecimiento_envia_nombre.toUpperCase()
                      : null}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label>Establecimiento que recibe:</label>
                  <div className="form-control">
                    {this.props.state.bitacora_producto
                      ? this.props.state.bitacora_producto.bitacora_movimiento.establecimiento_recibe_nombre.toUpperCase()
                      : null}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label>Nombre comercial del producto:</label>
                  <div className="form-control">
                    {this.props.state.bitacora_producto
                      ? this.props.state.bitacora_producto
                          .producto_nombre_comercial
                      : null}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label>Presentación producto:</label>
                  <div className="form-control">
                    {this.props.state.bitacora_producto
                      ? this.props.state.bitacora_producto
                          .rel_producto_empaque_texto
                      : null}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label>Fabricante producto:</label>
                  <div className="form-control">
                    {this.props.state.bitacora_producto
                      ? this.props.state.bitacora_producto.fabricante
                          .razon_social
                      : null}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label>Folio de egreso:</label>
                  <div className="form-control">
                    {this.props.state.bitacora_producto
                      ? this.props.state.bitacora_producto
                          .folio_bitacora_producto
                      : null}
                  </div>
                </div>
              </div>
            </div>

            <br />

            <div className="row">
              <div className="col-lg-12">
                <table className="table table-striped mb-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Lote</th>
                      <th className="text-center">Fecha fabricación</th>
                      <th className="text-center">Vencimiento lote</th>
                      <th className="text-center">Cantidad enviada</th>
                      <th className="text-center">Cantidad aceptada</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.state.bitacora_producto &&
                    this.props.state.bitacora_producto
                      .rel_bitacora_producto_lote.length > 0
                      ? this.props.state.bitacora_producto.rel_bitacora_producto_lote.map(
                          (item, index) => (
                            <tr key={index}>
                              <td className="text-center" width={"20%"}>
                                {item.num_lote}
                              </td>
                              <td className="text-center" width={"20%"}>
                                {item.fecha_fabricacion
                                  .split(" ")[0]
                                  .split("-")
                                  .reverse()
                                  .join("/")}
                              </td>
                              <td className="text-center" width={"20%"}>
                                {item.vencimiento_lote
                                  .split(" ")[0]
                                  .split("-")
                                  .reverse()
                                  .join("/")}
                              </td>
                              <td className="text-center" width={"20%"}>
                                {item.cantidad_enviada}
                              </td>
                              <td className="text-center" width={"20%"}>
                                <input
                                  type="text"
                                  value={
                                    this.props.state.cantidades_lotes[index]
                                      .cantidad_aceptada ?? ""
                                  }
                                  onChange={this.props.handleCantidadLoteInput}
                                  name={`cantidad_lote-${index}`}
                                  id={`cantidad_lote-${index}`}
                                  className="form-control text-center"
                                  placeholder="Ingrese cantidad"
                                />
                                <div
                                  className="invalid-feedback"
                                  style={{ display: "none" }}
                                  id={`cantidad_lote-${index}-error`}
                                ></div>
                              </td>
                            </tr>
                          )
                        )
                      : null}
                  </tbody>
                </table>
              </div>
            </div>

            <hr />

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label htmlFor="observaciones">Observaciones:</label>
                  <textarea
                    name="observaciones"
                    id="observaciones"
                    value={this.props.state.observaciones}
                    onChange={this.props.handleObservationChange}
                    className="form-control"
                    placeholder="Ingrese observaciones"
                  ></textarea>
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id={"observaciones-error"}
                  ></div>
                </div>
              </div>
            </div>

            <hr />

            <button
              type="button"
              onClick={this.props.rejectedAll}
              className="btn btn-danger pull-left"
            >
              Rechazar movimiento
            </button>

            <button type="submit" className="btn btn-success pull-right">
              Aceptar movimiento
            </button>

            {/* </div> */}
          </fieldset>
        </div>
      </>
    );
  }
}

export default MoveForm;
